<template>
  <div>
    <vue-tags-input
      v-model="tag"
      :tags="tags"
      @tags-changed="updateTags($event)"
      :add-on-key="[9,13]"
      :max-tags="5"
    />
  </div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';

export default {
    components: {
        VueTagsInput
    },
    data() {
        return {
            tag: '',
            tags: []
        };
    },
    methods: {
        updateTags(event) {
            this.tags = event;
            this.tags.forEach(x => (x.style = 'background-color: black'));
            this.$emit('input', event);
        }
    }
};
</script>

<style>
.custom {
    background-color: #000;
    color: rgba(100, 100, 100, 1);
    font-weight: bold;
    text-transform: uppercase;
    box-shadow: 2px 2px 0px 0px rgba(100, 100, 100, 1);
    margin-right: 4px;
    border: 1px solid rgba(100, 100, 100, 1);
    border-radius: 0px;
    font-size: 17px;
}
</style>
